import KpiOverview from '../components/overview/VesselKpiOverview';
import KpiDeployment from '../components/deployment/KpiDeployment';
import KpiCohortBenchmarking from '../components/cohort/KpiCohortBenchmarking';
import { useAppDispatch, useAppSelector } from '../../../core/rootHooks';
import { AppDispatch, RootState } from '../../../core/store';
import { vesselCohortVesselSelector } from '../../common/cohort/cohortSelector';
import { selectedCohortSourceVesselsSelector } from '../../common/cohort/cohortSourceSelector';
import { vesselVoyagesSelector } from '../kpiSelectors';
import { useEffect } from 'react';
import { kpisActions } from '../kpiSlice';
import { IKpiVessel } from '../kpiTypes';
import { ITabPage } from '../../../shared/components/tabs/ITabPage';
import DynamicTab from '../../../shared/components/tabs/DynamicTab';
import LoadingSpinner from '../../../shared/components/loading-spinner/LoadingSpinner';
import { selectFeatureDateRangeAnalysisDateRange } from '../../date-range/slices/dateRangeSlice';

const VesselKpi: React.FC<ITabPage<IKpiVessel>> = ({ ...props }) => {

	if (!props.data || !props.data.imoNumber) {
		return;
	}

	const { cohortVessels, minSize, maxSize, rangeSize, minAge, maxAge } = useAppSelector((state: RootState) =>
		selectedCohortSourceVesselsSelector(state, props.data.imoNumber!),
	);
	
	const vesselForCohort = useAppSelector((state: RootState) => vesselCohortVesselSelector(state, props.data.imoNumber!));

	const vesselVoyages = useAppSelector((state: RootState) => vesselVoyagesSelector(state, props.data.imoNumber!));

	const analysisDateRange = useAppSelector(selectFeatureDateRangeAnalysisDateRange);

	const dispatch = useAppDispatch<AppDispatch>();

	useEffect(() => {
		if (props.data.imoNumber) {
			const startDate = analysisDateRange.dateRange!.start.toDate('UTC').toISOString();
			const endDate = analysisDateRange.dateRange!.end.toDate('UTC').toISOString();

			dispatch(kpisActions.getVesselVoyagesRequestAction({ imoNumber: props.data.imoNumber, startDate, endDate }));
		}
	}, [dispatch, props.data.imoNumber, analysisDateRange]);

	const tabs = [
		{
			id: 'overview',
			label: 'Overview',
			content: <KpiOverview data={props.data} />,
		},
		{
			id: 'deployment',
			label: 'Deployment',
			content: <KpiDeployment vessel={props.data} vesselVoyages={vesselVoyages} />,
		},
		{
			id: 'cohort-benchmarking',
			label: 'Cohort Benchmarking',
			content: (
				<KpiCohortBenchmarking
					vessel={vesselForCohort}
					cohortVessels={cohortVessels}
					vesselVoyages={vesselVoyages}
					minSize={minSize}
					maxSize={maxSize}
					rangeSize={rangeSize}
					minAge={minAge}
					maxAge={maxAge}
				/>
			),
		},
	];

	return (
		<>
			{vesselVoyages === null ? (
				<LoadingSpinner size="md" spinnerClassName="p-2" />
			) : vesselVoyages != null &&
			  vesselVoyages.isFetched &&
			  (!vesselVoyages.dataList || vesselVoyages.dataList.length === 0) ? (
				<div className="flex w-full h-full justify-center">
					<span>No signals found! (VesselKpi)</span>
				</div>
			) : (
				<DynamicTab items={tabs} key={props.data.imoNumber} tabColor="msi-darkgrey-color" giveSpace={props.giveSpace} />
			)}
		</>
	);
};

export default VesselKpi;
